import * as React from "react";

var Footer = function Footer(props) {
  var _polizaRenewal$poliza;

  var polizaRenewal = props.polizaRenewal;
  var polizaId = polizaRenewal.poliza_id;
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/"),
    className: "btn btn-default btn-mini"
  }, "Ver email de despacho de poliza"), /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/edit"),
    className: "btn btn-default btn-mini"
  }, "Editar Poliza"), (_polizaRenewal$poliza = polizaRenewal.poliza) !== null && _polizaRenewal$poliza !== void 0 && _polizaRenewal$poliza.new_poliza_id ? /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaRenewal.poliza.new_poliza_id, "/"),
    className: "btn btn-default"
  }, "Ver nueva Poliza") : /*#__PURE__*/React.createElement("a", {
    href: "/admin/polizas/".concat(polizaId, "/renew"),
    className: "btn btn-primary"
  }, "Crear nueva Poliza"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Cerrar"));
};

export default Footer;